enum Roles {
  CARRIER = 'ROLE_CARRIER',
  SHIPPER = 'ROLE_SHIPPER',
}

interface CompanyFormValues {
  name: string;
  zip: string;
  taxId: string;
  role: Roles;
}

export { Roles };
export type { CompanyFormValues };
